import { Widget } from '@creditsights/styleguide-web';
import React from 'react';
import AnalystsContent from '../../components/widgets/Analysts/AnalystsContent';
import useFetchAnalysts from '../../hooks/analyst/useFetchAnalysts';

const CustomPageAuthors = ({ tagIds }: { tagIds: string[] }): React.ReactElement => {
  const { data: analysts, isLoading } = useFetchAnalysts({ analystIds: tagIds });

  return (
    <Widget dataTestId="custom-page-authors" headerTitle="Authors" fixedHeight isLoading={isLoading}>
      {analysts ? <AnalystsContent data={analysts} /> : <div>Authors not found</div>}
    </Widget>
  );
};

export default CustomPageAuthors;
